import { useEffect } from 'react';

export function useShortcuts(handlers) {
  useEffect(() => {
    const onKey = (e) => {
      const target = e.target;
      const editable =
        target &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.tagName === 'SELECT' ||
          target.isContentEditable);
      const mod = e.ctrlKey || e.metaKey;
      const key = e.key.toLowerCase();

      if (mod && !e.shiftKey && key === 'z') {
        if (editable) return;
        e.preventDefault();
        handlers.undo?.();
      } else if (mod && (key === 'y' || (e.shiftKey && key === 'z'))) {
        if (editable) return;
        e.preventDefault();
        handlers.redo?.();
      } else if (key === 'escape') {
        handlers.escape?.();
      } else if (!editable && (key === 'delete' || key === 'backspace')) {
        e.preventDefault();
        handlers.delete?.();
      } else if (!editable && key === 'arrowleft') {
        handlers.prev?.();
      } else if (!editable && key === 'arrowright') {
        handlers.next?.();
      } else if (mod && key === 'a' && !editable) {
        e.preventDefault();
        handlers.selectAll?.();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [handlers]);
}
